<template>
  <div class="trial-premium">
    <div class="bubble-dots">
      <span class="dot dot-1"></span>
      <span class="dot dot-2"></span>
    </div>
    <div class="trial-info">
      <span class="text-gray font-bold">トライアル終了まで残り</span>
      <div class="font-bold" :class="{ 'text-green': premiumTrialDate > 7, 'text-red': premiumTrialDate <= 7 }">
        <span class="text-size-24">{{ premiumTrialDate }}</span>日
      </div>
      <button class="btn btn-custom" @click="handleClickViewPremiumTrial()">
        <i class="fa fa-hand-o-right"></i>
        継続はコチラ
      </button>
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    premiumTrialDate () {
      return this.$store.getters.getUser.premiumTrialDate
    }
  },
  methods: {
    handleClickViewPremiumTrial () {
      if (this.$route.path === '/setting/plan-info') {
        return false
      }

      this.$router.push('/setting/plan-info')
    }
  }
}
</script>
<style scoped>
  .trial-premium {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .bubble-dots {
    display: inline-flex;
    align-items: baseline;
  }

  .bubble-dots .dot {
    background-color: #e8f5e9;
    border-radius: 50%;
  }

  .dot-1 {
    width: 15px;
    height: 15px;
  }

  .dot-2 {
    width: 20px;
    height: 20px;
  }

  .trial-info {
    display: flex;
    align-items: center;
    background-color: #e8f5e9;
    border-radius: 20px;
    padding: 5px 25px;
    width: fit-content;
    gap: 10px;
  }

  .text-green {
    color: #388e3c;
  }

  .text-gray {
    color: #666666;
  }

  .btn-custom {
    background-color: #388e3c;
    color: #fff;
    padding: 3px 15px;
  }

  @media (max-width: 1024px) {
    .trial-premium {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PremiumTrial.vue